import { fetcher } from "helpers/fetcher";

import {
  TGetUserAssociatedCorpListReq,
  TGetUserAssociatedCorpListRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserAssociatedCorpList = async (
  params?: TGetUserAssociatedCorpListReq
) => {
  return await fetcher<
    TGetUserAssociatedCorpListRes,
    TGetUserAssociatedCorpListReq
  >(ENDPOINT.CORPORATION.USER_ASSOCIATED_CORP_LIST, {
    params: params,
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.USER_ASSOCIATED_CORP_LIST.version,
    },
  });
};

export const queryGetUserAssociatedCorpList = async (
  params?: TGetUserAssociatedCorpListReq
) => {
  return (await getUserAssociatedCorpList(params)).data;
};

queryGetUserAssociatedCorpList._key = (
  params?: TGetUserAssociatedCorpListReq
) => [ENDPOINT.CORPORATION.USER_ASSOCIATED_CORP_LIST.url, params];
